import React, { useState, useEffect } from "react";
import "../../styles/common/folderPopup.scss";

const FolderPopup = ({ open, handleClose, folder, onSave }) => {
  const [folderName, setFolderName] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [originalFolderName, setOriginalFolderName] = useState("");

  useEffect(() => {
    if (folder) {
      setFolderName(folder.name || "");
      setOriginalFolderName(folder.name || "");
    } else {
      setFolderName("");
      setOriginalFolderName("");
    }
  }, [folder]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!folderName.trim()) {
      alert("Please enter a folder name");
      return;
    }

    try {
      setIsSaving(true);
      await onSave({ name: folderName.trim() });
    } catch (err) {
      console.error("Error saving folder:", err);
    } finally {
      setIsSaving(false);
    }
  };

  const handleInputChange = (e) => {
    setFolderName(e.target.value);
  };

  if (!open) return null;

  return (
    <div className="folder-popup-overlay">
      <div className="folder-popup">
        <div className="folder-popup-header">
          <h3>{folder ? "Edit Folder" : "Create Folder"}</h3>
          <button
            type="button"
            className="close-btn"
            onClick={handleClose}
            disabled={isSaving}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="folder-popup-form">
          <div className="form-group">
            <label htmlFor="folderName">Folder Name</label>
            <input
              type="text"
              id="folderName"
              value={folderName}
              onChange={handleInputChange}
              placeholder="Enter folder name"
              disabled={isSaving}
              autoFocus
              required
            />
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="secondary-btn"
              onClick={handleClose}
              disabled={isSaving}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="primary-btn"
              disabled={
                isSaving ||
                !folderName.trim() ||
                (folder && folderName.trim() === originalFolderName.trim())
              }
            >
              {isSaving ? "Saving..." : folder ? "Update" : "Create"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FolderPopup;
